"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineEdit = InlineEdit;
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../elements/button/Button");
var _Loader = require("../../elements/loader/Loader");
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _inlineEditModule = _interopRequireDefault(require("./inline-edit.module.scss"));
function InlineEdit(_ref) {
  var onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    input = _ref.input,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    buttonClassName = _ref.buttonClassName,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_inlineEditModule.default['inline-edit'], className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "inline-edit-input",
    className: (0, _classnames.default)(_inlineEditModule.default['inline-edit__input'], inputClassName)
  }, input), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "inline-edit-button",
    className: (0, _classnames.default)(_inlineEditModule.default['inline-edit__button-container'], buttonClassName)
  }, /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    small: true,
    onClick: onSave,
    className: _inlineEditModule.default['inline-edit__primary-button']
  }, t('inlineEdit.save'), loading && /*#__PURE__*/_react.default.createElement(_Loader.Loader, {
    "data-testid": "inline-edit-loader",
    small: true,
    variant: "primary-button",
    className: _inlineEditModule.default['inline-edit__loader']
  })), /*#__PURE__*/_react.default.createElement(_Button.NeutralButton, {
    small: true,
    onClick: onCancel,
    className: _inlineEditModule.default['inline-edit__secondary-button']
  }, t('inlineEdit.cancel'))));
}